// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"787":"ad88a3cc","828":"aeaf7ff6","937":"c62885d6"}[chunkId] + ".chunk.css";
};